import { Pipe, PipeTransform } from '@angular/core';
import { MediaSrc } from '../media-src.type';
import { mediaConst } from './../media.constants';

@Pipe({ name: 'mediaSrcStrapi' })
export class MediaSrcStrapiPipe implements PipeTransform {
  // todo extend for formats
  transform(media /*:something*/, base = ''): MediaSrc {
    if (!media) {
      return { default: '' };
    }

    if (media.base) {
      base = media.base;
    }

    const mediaSrc: MediaSrc = {
      default: base + media.url,
    };

    if (media.webPURL && mediaConst.allowExt.find((ext) => media.url.endsWith('.' + ext))) {
      mediaSrc.set = [
        {
          srcset: base + media.webPURL,
          type: 'image/webp',
        },
      ];
    }

    const theAvailableFormats = [];
    let theAvailableFormatsSorted = [];

    if (media.formats) {
      const availableFormats = media.formats;
      for (const [key, value] of Object.entries(availableFormats)) {
        theAvailableFormats.push(value);
      }
      theAvailableFormatsSorted = theAvailableFormats.sort((a, b) => parseFloat(b.width) - parseFloat(a.width));
      mediaSrc.set = [
        {
          base,
          srcset: base + media.formats.small.url,
          media: media.formats.small.width,
          breakpoints: theAvailableFormatsSorted,
        },
      ];
    }

    return mediaSrc;
  }
}
